/**
 * Math utility for infiltration calculations
 */
class MathUtility {
    /**
     * Resolves index notation (significand * 10^exponent) and rounds to 7 decimal places
     *
     * @param {number|string} significand
     * @param {number|string} exponent
     * @returns {number}
     */
    static resolveIndexNotation(significand, exponent) {
        if (!significand || !exponent) {
            return 0;
        }
        const val = parseFloat(significand) * Math.pow(10, parseInt(exponent));
        return Math.round(val * 10000000) / 10000000;
    }

    /**
     * Formats a float for display (German decimal separator)
     *
     * @param {number} value
     * @returns {string}
     */
    static formatFloat(value) {
        return value.toString().replace('.', ',');
    }

	static round(number, precision) {
		let precisionMultiplicative = Math.pow(10, precision);

		return Math.round(number * precisionMultiplicative) / precisionMultiplicative;
	}
}

export default MathUtility;
